import React from 'react';  // eslint-disable-line

const More = () => {
    return (
        <svg width="22px" height="6px" viewBox="0 0 22 6" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-13.000000, -3.000000)" stroke="#CDCDCD" strokeWidth="0.67">
                    <g transform="translate(14.000000, 4.000000)">
                        <circle cx="2" cy="2" r="2" />
                        <circle cx="10" cy="2" r="2" />
                        <circle cx="18" cy="2" r="2" />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default More;
